export const TemplateChoiceType = {
    RECOMMENDATION: 'RECOMMENDATION',
    LIST_VIEW: 'LIST_VIEW',
};
